import React, { useEffect } from "react";
import { TableBody } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { connect } from "react-redux";

import { JOB_STATUSES } from "../../constants";
import OrderLineItemRow from "./OrderLineItemRow";
import { getUserPermissionById } from "../../redux";
import {
  PERMISSION_LEVEL_KEYS,
  PERMISSIONS_KEY,
} from "../../constants/permissions";

const OrderLineItemsBody = ({
  items = [],
  part = {},
  lineItemId,
  permissioin,
}) => {
  const { setValue, getValues, register, watch } = useFormContext();

  useEffect(() => {
    register("deletedWorkOrders");
    setValue("deletedWorkOrders", []);
  }, [register]);

  const lineItems = getValues("lineItems");
  const locationId = lineItems?.find((li) => li.id === lineItemId)?.locationId;

  const deletedValues = watch("deletedWorkOrders") || [];
  const updatedItems = watch("updatedWorkOrders") || [];
  const itemPayload = { part, deletedValues, updatedItems, locationId };

  return (
    <TableBody>
      {items?.map((item, idx) => {
        let disabled = item?.state != JOB_STATUSES.NOT_STARTED && item?.state;
        let warnChange = false;
        if (permissioin && disabled) {
          disabled = false;
          warnChange = true;
        }
        const payload = { item, idx, disabled, ...itemPayload, warnChange };
        return <OrderLineItemRow key={JSON.stringify(item)} {...payload} />;
      })}
    </TableBody>
  );
};

const mapStateToProps = (state) => ({
  permissioin: getUserPermissionById(
    state,
    PERMISSIONS_KEY.LINE_ITEMS,
    PERMISSION_LEVEL_KEYS.DELETE
  ),
});
export default connect(mapStateToProps)(OrderLineItemsBody);
